import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleAccordion.module.scss';
import ArticleAccordionSection from '../ArticleAccordionSection';

/**
 * Accordion which displays multiple sections. Each section has a title and text.
 */
const ArticleAccordion = (props) => {
  const { sections, activeSectionIndex: activeSectionIndexProp } = props;

  const [activeSectionIndex, setActiveSectionIndex] = useState(
    activeSectionIndexProp
  );

  const [isAccordionAnimating, setIsAccordionAnimating] = useState(false);

  const toggleSection = (clickIndex) => {
    if (isAccordionAnimating) return;

    setIsAccordionAnimating(true);
    if (activeSectionIndex !== clickIndex) {
      setActiveSectionIndex(clickIndex);
    } else {
      setActiveSectionIndex(-1);
    }
  };

  return (
    <div className={style.accordion}>
      {sections?.map((section, index) => (
        <ArticleAccordionSection
          currentSectionIndex={index}
          activeSectionIndex={activeSectionIndex}
          toggleSection={toggleSection}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          title={section?.accordionTitle}
          textMultiEntries={section?.accordionTextMultiEntry}
          setIsAccordionAnimating={setIsAccordionAnimating}
        />
      ))}
    </div>
  );
};

ArticleAccordion.defaultProps = {
  activeSectionIndex: 0,
};

ArticleAccordion.propTypes = {
  /** Array of sections of following structure: { accordionTitle, accordionTextMultiEntry } */
  sections: PropTypes.array.isRequired,
  /** Index of a section open by default */
  activeSectionIndex: PropTypes.number,
};

export default ArticleAccordion;
